<p class="ibk-description" *ngIf="isClient">
  Valida tu identidad como representante legal
</p>
<div class="ba-field-group">
  <b>{{getTextCapitalize(firstName)}}</b>
</div>
<div class="ba-field-group">
  <span>
    Para validar tu identidad, te enviaremos un c&oacute;digo de verificaci&oacute;n al correo que tienes registrado en
    el banco:
  </span>
</div>
<div class="ba-field-group bordered" formGroupName="emailOtp" *ngIf="emails.length">
  <ibk-input-radio-group dsRxForm="radioChange" #taxControl="control" formControlName="email" name="email"
    class="radio-group">
    <label>
      Correo electr&oacute;nico
    </label>
    <br />
    <br />
    <ibk-input #inputEmail *ngFor="let email of emails; let i = index" class="field">
      <input [value]="email" />
      <span class="text-lower">{{ email | obfuscateOtpEmail:'ALL' }}</span>
    </ibk-input>
  </ibk-input-radio-group>
</div>
<div class="ba-field-group d-block">
  <span class="ibk-description">
    ¿No es tu correo o deseas actualizarlo?
  </span>
  <br />
  <a href="#" class="ibk-description text-primary" (click)="toggleFlowVisibility(true,$event)">
    Conoce como actualizarlo
  </a>
</div>
<ibk-toast *ngIf="showValidation" type="WARN">
  Contactate con la banca telefónica.
</ibk-toast>

<ibk-button class="ba-action" [loading]="isLoading">
  <button [disabled]="emailOtpForm.invalid" id="get-code-otp-step-next"
    class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn" (click)="validationCodeOtpStep()">
    Siguiente
  </button>
</ibk-button>
<ibk-button class="ba-action">
  <button id="get-code-otp-step-previous" class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn btn-white-primary"
    (click)="lastStep()">
    Anterior
  </button>
</ibk-button>

<ibk-modal *ngIf="isFlowActive" hide-close max-width="350px" min-width="350px" (closed)="toggleFlowVisibility(false)"
  [opened]="isFlowActive">
  <ba-data-update (toggleFlowVisibility)="toggleFlowVisibility($event)"></ba-data-update>
</ibk-modal>